import React, { useState } from 'react'
import { Icon } from '@iconify/react'

import ProjectHealthDashboard from './ProjectHealthDashboard'
import ProjectCapacityDashboard from './ProjectCapacityDashboard'
import styles from './ReportsView.module.css'

const REPORT_TYPES = [
    {
        key: 'health',
        label: 'Project Health',
        description: 'Estimated vs logged hours by member',
        icon: 'mdi:heart-pulse',
    },
    {
        key: 'capacity',
        label: 'Project Capacity',
        description: 'Team workload and resource allocation',
        icon: 'mdi:account-clock-outline',
    },
]

const ReportsView = ({ projectId, projectName }) => {
    const [activeReport, setActiveReport] = useState('health')

    return (
        <div className={styles.reportsLayout}>
            <aside className={styles.reportsNav} aria-label="Report types">
                <p className={styles.reportsNavTitle}>Reports</p>
                {REPORT_TYPES.map((report) => {
                    const isActive = activeReport === report.key
                    return (
                        <button
                            key={report.key}
                            type="button"
                            className={`${styles.reportsNavItem} ${
                                isActive ? styles.reportsNavItemActive : ''
                            }`}
                            onClick={() => setActiveReport(report.key)}
                            aria-current={isActive ? 'page' : undefined}
                        >
                            <Icon
                                icon={report.icon}
                                width={18}
                                height={18}
                                className={styles.reportsNavIcon}
                            />
                            <span className={styles.reportsNavItemText}>
                                <span className={styles.reportsNavItemLabel}>
                                    {report.label}
                                </span>
                                <span className={styles.reportsNavItemDesc}>
                                    {report.description}
                                </span>
                            </span>
                        </button>
                    )
                })}
            </aside>
            <main className={styles.reportsMain}>
                {activeReport === 'health' && (
                    <ProjectHealthDashboard
                        projectId={projectId}
                        projectName={projectName}
                    />
                )}
                {activeReport === 'capacity' && (
                    <ProjectCapacityDashboard projectName={projectName} />
                )}
            </main>
        </div>
    )
}

export default ReportsView
